import React from 'react';
var Highcharts = require('highcharts');
import moment from 'moment';

export default class CampaignDaysPosting extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        this.renderChart();
    }

    componentDidUpdate() {
        this.renderChart();
    }

    renderChart() {
        Highcharts.chart('campaign_days_container',
            {
                chart: {
                    height: this.props.height,
                    type: 'area',
                    marginRight: this.props.lineData.length > 0 ? 100 : 0,
                    marginLeft: 100
                },
                tooltip: {
                    formatter: function () {
                        const header = `${this.key}<br/>`; // Header for category or series
                        const body = `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</b>`;
                        return header + body;
                    },
                    style: {
                        fontSize: '12px'
                    }
                },
                title: {
                    text: null
                },

                xAxis: {
                    categories: this.props.areaData.map((x) => { return moment(x.date).format('YYYY-MM-DD HH:mm'); }),
                    tickLength: 5,
                    tickPositions: this.getTickPositions(),
                    tickWidth: 0.3,
                    lineWidth: 0.3,
                    labels: {
                        style: { fontSize: '9px'},
                        formatter: function () {
                            var label = this.axis.defaultLabelFormatter.call(this);
                            return moment(label).format('MMM-DD');
                        }
                    }
                },

                yAxis: [{
                    title: {
                        text: this.props.areaName,
                        style: { fontSize: '12px' },
                    },
                    labels: {
                        enabled: true,
                        formatter: function () {
                            return this.value
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        },
                        style: { fontSize: '9px' }
                    },
                    min: Math.min.apply(Math, this.props.areaData.map((x) => {
                        return x.delivered;
                    })) * 0.75,
                    max: Math.max.apply(Math, this.props.areaData.map((x) => {
                        return x.delivered;
                    })) * this.props.areaMaxScale
                },
                {
                    title: {
                        text: this.props.lineData.length > 0 ? this.props.lineName : '',
                        style: { fontSize: '12px' },
                    },
                    labels: {
                        enabled: true,
                        formatter: function () {
                            return this.value
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        },
                        style: { fontSize: '9px' }
                    },
                    min: Math.min.apply(Math, this.props.lineData.map((x) => {
                        return x.delivered;
                    })) * 0.75,
                    max: Math.max.apply(Math, this.props.lineData.map((x) => {
                        return x.delivered;
                    })) * this.props.lineMaxScale,
                    opposite: true
                }],
                legend: {
                    enabled: true,
                    align: "right",
                    verticalAlign: "top",
                    y: -5,
                    x: -75,
                    floating: true,
                    itemStyle: {
                        fontSize: '1.3rem',
                        fontWeight: 'bold'
                    }
                },

                credits: false,

                plotOptions: {
                    series: { enableMouseTracking: true },
                    area: {
                        fillOpacity: 1,
                        marker: {
                            enabled: false
                        }
                    }
                },
                series: this.getSeries()
            });
    }

    getSeries() {
        let series = [{
            yAxis: 0,
            name: this.props.areaName,
            color: this.props.color2,
            type: "area",
            data: this.props.areaData.map((x) => { return x.delivered })
        }];
        if (this.props.lineData.length > 0) {
            series.push({
                yAxis: 1,
                name: this.props.lineName,
                color: this.props.color1,
                type: "line",
                marker: {
                    enabled: false
                },
                data: this.props.lineData.map((x) => { return x.delivered; })
            });
        }
        return series;
    }

    getTickPositions() {
        let tickPositions = [];
        let first = -1;
        for (var i = 0; i < this.props.lineData.length; i++) {
            if (moment(this.props.lineData[i].date).format('HH') === '00') {
                if (first === -1) {
                    first = i;
                }
                if (this.props.byDay !== true) {
                    tickPositions.push(i);  //set tick positions to midnight each day when we show hourly values
                } else {
                    if (tickPositions.length === 0) {
                        tickPositions.push(i);
                    } else {
                        if ((i + first) % 7 === 0) {
                            tickPositions.push(i); //set tick positions to midnight every 7th day when we show daily values
                        }
                    }
                }
            }
        }
        return tickPositions;
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <h4>{this.props.graphHeader}</h4>
                </div>
                <div className="col-md-12" >
                    <div id="campaign_days_container" style={{height: + this.props.height + 'px'}}></div>
                </div>
            </div>
        );
    }
}